import { render, staticRenderFns } from "./create-sponsor-config.vue?vue&type=template&id=25c55b66&"
import script from "./create-sponsor-config.vue?vue&type=script&lang=js&"
export * from "./create-sponsor-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports